import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import logoImage from '../../assets/lws.svg';
import searchImage from '../../assets/search.svg';
import { clearAllFilter } from '../../features/filter/filterSlice';
import Search from './Search';

export default function Navbar() {
  const { author, search, tags } = useSelector((state) => state.filter);
  const dispatch = useDispatch();
  const HandleClearFilter = () => {
    dispatch(clearAllFilter());
  };

  let content = null;
  if (author !== '' || search !== '' || tags.length > 0) {
    content = (
      <p
        onClick={() => HandleClearFilter()}
        className="bg-blue-100 text-red-400 lg:px-4  px-1 py-1 lg:py-2 rounded-full cursor-pointer"
      >
        Clear Filters
      </p>
    );
  }
  return (
    <nav className="bg-slate-100 shadow-md">
      <div className="max-w-7xl mx-auto px-5 lg:px-0 flex justify-between py-3">
        <Link to="/">
          <img className="h-10" src={logoImage} alt="Learn with Sumit" />
        </Link>
        <div className="border border-slate-200 flex items-center bg-white h-10 px-5 rounded-lg text-sm ring-emerald-200">
          <Search />
          <img
            className="inline h-4 cursor-pointer"
            src={searchImage}
            alt="Search"
          />
        </div>
        {content}
      </div>
    </nav>
  );
}
